import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

export function useTestimonials() {
    const [items, setItems] = useState(cache || []);
    useEffect(() => {
        if (cache) return;
        fetch(`${API}/testimonials`)
            .then((r) => (r.ok ? r.json() : []))
            .then((data) => {
                cache = data;
                setItems(data);
            })
            .catch(() => setItems([]));
    }, []);
    return items;
}
